import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Skeleton,
  Box,
} from "@mui/material";

const AuditTable = ({ auditList, progress = false }) => {
  const rows = Array.isArray(auditList?.data) ? auditList.data : [];
  const hasData = rows.length > 0;

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Id
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                User ID
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                User Action
              </Typography>
            </TableCell>
            <TableCell>
              <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                Date & Time
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {progress ? (
            Array.from({ length: 5 }).map((_, idx) => (
              <TableRow key={`skeleton-${idx}`}>
                <TableCell colSpan={4}>
                  <Skeleton variant="rounded" height={28} />
                </TableCell>
              </TableRow>
            ))
          ) : hasData ? (
            rows.map((row) => (
              <TableRow key={row.id} hover>
                <TableCell>{row.id}</TableCell>
                <TableCell>{row.user_id}</TableCell>
                <TableCell>
                  <Typography variant="body2" sx={{ wordBreak: "break-word" }}>
                    {row.user_action || "—"}
                  </Typography>
                </TableCell>
                <TableCell sx={{ whiteSpace: "nowrap" }}>
                  {row.time_created
                    ? new Date(row.time_created).toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        second: "2-digit",
                      })
                    : "—"}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={4} align="center">
                <Box sx={{ py: 4 }}>
                  <Typography variant="h6">No Audits Found</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Audit activity will appear here as users log in and search.
                  </Typography>
                </Box>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AuditTable;
